<div *forRoles="['ACTIVE_MEMBER']">
  <div class="row row-cols-1 row-cols-lg-2 row-cols-xl-4">
    <div class="col-lg-12">
      <div class="card bg-info">
        <a routerLink="/profile">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div>
                <h5 class="my-1 text-white">Certificate/Statement</h5>
              </div>
              <div class="widgets-icons text-dark ms-auto"><i class='lni lni-certificate'></i>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="card bg-danger">
        <a routerLink="/work-permits">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <h5 class="my-1 text-white">Work Permits</h5>
              <p>
                &nbsp;
             </p>
              <div class="widgets-icons text-success ms-auto"><i class='lni lni-book'></i>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="card bg-violet">
        <a routerLink="/budget-proposals">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div>
                <h5 class="my-1 text-white">Budget Proposals</h5>
              </div>
              <div class="widgets-icons text-danger ms-auto"><i class='lni lni-book'></i>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="card bg-success">
        <a routerLink="/drs-applications">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div>
                <h5 class="my-1 text-white">DRS Applications</h5>
              </div>
              <div class="widgets-icons text-dark ms-auto"><i class='lni lni-control-panel'></i>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
  <hr>
  <div class="row row-cols-1 row-cols-lg-2 row-cols-xl-4">
    <div class="col-lg-12">
      <div class="card bg-danger">
        <a routerLink="/industrial-spares">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div>
                <h5 class="my-1 text-white">Industrial Spares Applications</h5>
              </div>
              <div class="widgets-icons text-dark ms-auto"><i class='lni lni-pencil-alt'></i>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="card bg-success">
        <a routerLink="/lmg">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <h5 class="my-1 text-white">LMG Applications</h5>
              <div class="widgets-icons text-success ms-auto"><i class='bx bxs-group'></i>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="card bg-info">
        <a routerLink="/non-tariff-barriers">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div>
                <h5 class="my-1 text-white">Non-Tariff Barriers</h5>
              </div>
              <div class="widgets-icons text-dark ms-auto"><i class='lni lni-customer'></i>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="card bg-violet">
        <a routerLink="/declaration-fees">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div>
                <h5 class="my-1 text-white">Import Declaration Fees</h5>
              </div>
              <div class="widgets-icons text-dark ms-auto"><i class='lni lni-delivery'></i>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
  <hr>
  <div class="row row-cols-1 row-cols-lg-2 row-cols-xl-4">
    <!-- <div class="col-lg-12">
      <div class="card bg-success">
        <a routerLink="/budget-proposals">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <h6 class="my-1 text-white">Budget Proposal Applications</h6>
              <div class="widgets-icons text-success ms-auto"><i class='bx bxs-group'></i>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div> -->
    <div class="col-lg-12">
      <div class="card bg-success">
        <a routerLink="/events">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div>
                <h5 class="my-1 text-white">Events</h5>
              </div>
              <div class="widgets-icons text-dark ms-auto"><i class='lni lni-layers'></i>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="card bg-info">
        <a routerLink="/events/trainings">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <h5 class="my-1 text-white">Trainings</h5>
              <div class="widgets-icons text-success ms-auto"><i class='lni lni-network'></i>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="card bg-violet">
        <a routerLink="/events/seminars">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div>
                <h5 class="my-1 text-white">Seminars</h5>
              </div>
              <div class="widgets-icons text-danger ms-auto"><i class='lni lni-investment'></i>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="card bg-danger">
        <a routerLink="/events/workshops">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div>
                <h5 class="my-1 text-white">Workshops</h5>
              </div>
              <div class="widgets-icons text-dark ms-auto"><i class='lni lni-layout'></i>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
  <hr>
  <div class="row row-cols-1 row-cols-lg-2 row-cols-xl-4">
    <div class="col-lg-12">
      <div class="card bg-danger">
        <a routerLink="/technical-assesments">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div>
                <h5 class="my-1 text-white">Technical Assessments</h5>
              </div>
              <div class="widgets-icons text-dark ms-auto"><i class='lni lni-grid-alt'></i>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="card bg-success">
        <a routerLink="/agoa-visas">
        <div class="card-body">
          <div class="d-flex align-items-center">
            <div>
              <h5 class="my-1 text-white">Agoa Visa Applications</h5>
            </div>
            <div class="widgets-icons text-danger ms-auto"><i class='lni lni-pencil-alt'></i>
            </div>
          </div>
        </div>
        </a>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="card bg-info">
        <a routerLink="/illicit-trade">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div>
                <h5 class="my-1 text-white">Illicit Trade Reporting</h5>
              </div>
              <div class="widgets-icons text-dark ms-auto"><i class='lni lni-calculator'></i>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="card bg-violet">
        <a routerLink="/help-desk">
        <div class="card-body">
          <div class="d-flex align-items-center">
            <div>
              <h5 class="my-1 text-white">Help Desk</h5>
            </div>
            <div class="widgets-icons text-success ms-auto"><i class='lni lni-question-circle'></i>
            </div>
          </div>
        </div>
        </a>
      </div>
    </div>
  </div>
  <hr>
  <div class="row row-cols-1 row-cols-lg-2 row-cols-xl-4">
  </div>
  <hr>
</div>
<div *forRoles="['INACTIVE_MEMBER']">
  <div class="row row-cols-1 row-cols-md-2 row-cols-xl-4">
    <div class="col">
      <a routerLink="/member-applications/instructions">
        <div class="card radius-1 bg-success bg-gradient">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div>
                <p class="mb-0 text-white"></p>
                <h5 class="my-1 text-white">Instructions</h5>
              </div>
              <div class="text-white ms-auto font-35">
                <i class='bx bx-detail'></i>
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>
    <div class="col">
      <a routerLink="/member-applications">
        <div class="card radius-1 bg-primary bg-gradient">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div>
                <p class="mb-0 text-white"></p>
                <h5 class="my-1 text-white">My Application</h5>
              </div>
              <div class="text-white ms-auto font-35"><i class='bx bx-file-blank'></i>
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</div>
<div *forRoles="['NON_MEMBER']">
  <div class="row row-cols-1 row-cols-lg-2 row-cols-xl-4">
    <div class="col-lg-12">
      <div class="card bg-success">
        <a routerLink="/work-permits">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <h5 class="my-1 text-white">Work Permits Applications</h5>
              <div class="widgets-icons text-success ms-auto"><i class='bx bxs-group'></i>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="card bg-info">
        <a routerLink="/drs-applications">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div>
                <h5 class="my-1 text-white">DRS Application</h5>
              </div>
              <div class="widgets-icons text-dark ms-auto"><i class='lni lni-bulb'></i>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="card bg-violet">
        <a routerLink="/industrial-spares">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div>
                <h5 class="my-1 text-white">Industrial Spares Applications</h5>
              </div>
              <div class="widgets-icons text-dark ms-auto"><i class='lni lni-pencil-alt'></i>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="card bg-info">
        <a routerLink="/non-tariff-barriers">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div>
                <h5 class="my-1 text-white">Non-Tariff Barriers Reporting</h5>
              </div>
              <div class="widgets-icons text-dark ms-auto"><i class='lni lni-customer'></i>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
  <hr>
  <div class="row row-cols-1 row-cols-lg-2 row-cols-xl-4">
    <div class="col-lg-12">
      <div class="card bg-violet">
        <a routerLink="/events">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div>
                <h5 class="my-1 text-white">Event</h5>
              </div>
              <div class="widgets-icons text-dark ms-auto"><i class='lni lni-pencil-alt'></i>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="card bg-success">
        <a routerLink="/events/trainings">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <h5 class="my-1 text-white">Trainings</h5>
              <div class="widgets-icons text-success ms-auto"><i class='bx bxs-group'></i>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="card bg-danger">
        <a routerLink="/events/seminars">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div>
                <h5 class="my-1 text-white">Seminars</h5>
              </div>
              <div class="widgets-icons text-danger ms-auto"><i class='lni lni-service'></i>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="card bg-info">
        <a routerLink="/events/workshops">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div>
                <h5 class="my-1 text-white">Workshops</h5>
              </div>
              <div class="widgets-icons text-dark ms-auto"><i class='lni lni-bulb'></i>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
  <hr>
  <div class="row row-cols-1 row-cols-lg-2 row-cols-xl-4">
    <div class="col-lg-12">
      <div class="card bg-success">
        <a routerLink="/agoa-visas">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div>
                <h5 class="my-1 text-white">Agoa Visa Applications</h5>
              </div>
              <div class="widgets-icons text-success ms-auto"><i class='lni lni-help'></i>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="card bg-violet">
        <a routerLink="/special-passes">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div>
                <h5 class="my-1 text-white">Special Passes</h5>
              </div>
              <div class="widgets-icons text-dark ms-auto"><i class='lni lni-pencil-alt'></i>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="card bg-info">
        <a routerLink="/dependant-passes">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div>
                <h5 class="my-1 text-white">Dependant Passes</h5>
              </div>
              <div class="widgets-icons text-dark ms-auto"><i class='lni lni-bulb'></i>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
  <hr>
  <div class="row row-cols-1 row-cols-lg-2 row-cols-xl-4">
  </div>
</div>
